import React, { useState } from "react";
import { useAuth } from "../../lib/auth";
import { Copy, LogOut, Share2, Trophy, Smartphone } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function AccountProfile() {
    const { customer, logout } = useAuth();
    const navigate = useNavigate();
    const [c, setC] = useState(false);

    if (!customer) return null;

    const copyRef = () => {
        navigator.clipboard.writeText(customer.referral_code);
        setC(true);
        setTimeout(() => setC(false), 1500);
    };

    return (
        <div>
            <h1 className="font-display text-2xl md:text-3xl font-bold">Profile</h1>
            <div className="fx-card p-5 mt-5 flex items-center gap-3">
                <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#ccff00] to-[#ffd700] text-black flex items-center justify-center font-display font-bold text-xl">
                    {(customer.name || "F")[0].toUpperCase()}
                </div>
                <div className="flex-1">
                    <p className="font-semibold">{customer.name || `+${customer.mobile}`}</p>
                    <p className="text-xs text-[#6b7280]">+{customer.mobile} • {customer.loyalty_id}</p>
                </div>
                <span className="fx-chip bg-[#ffd700]/10 text-[#ffd700] border border-[#ffd700]/30">
                    <Trophy size={11} /> {customer.tier}
                </span>
            </div>

            <div className="fx-card p-5 mt-4">
                <span className="fx-chip bg-[#c9a959]/10 text-[#c9a959] border border-[#c9a959]/30">
                    <Share2 size={11} /> Refer & Earn
                </span>
                <p className="font-display text-lg font-semibold mt-3">Give 200 pts, get 200 pts.</p>
                <p className="text-xs text-[#6b7280]">Share your code with friends</p>
                <div className="mt-3 flex items-center gap-2">
                    <div className="flex-1 fx-glass rounded-xl px-4 py-2 font-mono font-bold tracking-widest">
                        {customer.referral_code}
                    </div>
                    <button onClick={copyRef} className="fx-btn-ghost !py-2 !px-4">
                        <Copy size={14} /> {c ? "Copied" : "Copy"}
                    </button>
                </div>
            </div>

            <div className="grid grid-cols-2 gap-3 mt-4">
                <a
                    href="https://wa.me/918072905306?text=Hi"
                    target="_blank"
                    rel="noreferrer"
                    className="fx-btn-ghost"
                >
                    <Smartphone size={14} /> WhatsApp
                </a>
                <button
                    data-testid="profile-logout-btn"
                    onClick={() => {
                        logout();
                        navigate("/");
                    }}
                    className="fx-btn-ghost !text-[#ff4d4d]"
                >
                    <LogOut size={14} /> Sign out
                </button>
            </div>
        </div>
    );
}
